import { instrumentQueryKeys } from '@/config/queryKeys';
import { INSTRUMENTS_QUERY_GC_TIME, INSTRUMENTS_QUERY_STALE_TIME } from '@/constants';
import { fetchInstruments } from '@/services/instruments';
import type { InstrumentPublic } from '@/types';
import { useQuery } from '@tanstack/react-query';

export function useInstruments(orgId: string, initialData?: InstrumentPublic[]) {
  return useQuery<InstrumentPublic[]>({
    queryKey: instrumentQueryKeys.list(orgId),
    queryFn: () => fetchInstruments(orgId),
    initialData,
    staleTime: INSTRUMENTS_QUERY_STALE_TIME,
    gcTime: INSTRUMENTS_QUERY_GC_TIME,
    enabled: !!orgId,
  });
}
